import { AutocompleteRenderGetTagProps, Chip } from '@mui/material'
import { useIsThemeV2 } from '@omnea-app/omui/NewThemeProvider'
import { AssigneeAvatar, AssigneeAvatarOption } from './AssigneeAvatar'

interface AssigneeAutocompleteTagChipProps {
  option: AssigneeAvatarOption
  label: string
  getTagProps: AutocompleteRenderGetTagProps
  index: number
  isValid: boolean
}

export const AssigneeAutocompleteTagChip = ({ option, label, getTagProps, index, isValid }: AssigneeAutocompleteTagChipProps) => {
  const isThemeV2 = useIsThemeV2()
  return (
    <Chip
      avatar={<AssigneeAvatar option={option} sx={{ marginLeft: 1 }} />}
      label={label}
      size="small"
      {...getTagProps({ index })}
      key={index}
      data-testid={`assignee-chip-${option.value}`}
      color={!isValid ? 'error' : 'default'}
      variant={isThemeV2 ? 'futureTheme.selection' : undefined}
    />
  )
}
